import React, { useState, useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';

import Policies from '../common/Policies';
import SelectedPoliciesDispatch from '../../contexts/selectedPolicies.dispatch';
import selectedPolicesReducer from '../../reducers/selectedPolices.reducer';
import endorsementTypes from '../../data/endorsementType';
import Select from '../common/Select';
import DatePicker from '../common/DatePicker';
import Error from '../common/Error';

import NameChange from './endorsements/NameChange';
import ChangeDesignatedOfficerContactPerson from './endorsements/ChangeDesignatedOfficerContactPerson';
import MailingAddressChange from './endorsements/MailingAddressChange';
import General from './endorsements/General';
import Other from './endorsements/Other';
import style from './EndorsementsRequestPage.module.css';

const EndorsementsRequestPage = React.memo(({ clientId }) => {
  const [stepTwo, setStepTwo] = useState(false);
  const [effDate, setEffDate] = useState();
  const [effDateError, setEffDateError] = useState();
  const [endorsementType, setEndorsementType] = useState('NameChange');
  const [selectedPolicesState, selectedPolicesDispatch] = useReducer(
    selectedPolicesReducer,
    {
      ids: [],
    },
  );

  useEffect(() => {
    if (selectedPolicesState.ids.length > 0) {
      setStepTwo(true);
    }
  }, [selectedPolicesState.ids]);

  const endorsementTypeStyle = {
    height: '44px',
    padding: '0 12px',
    fontSize: '16px',
    color: '#636176',
    textOverflow: 'ellipsis',
    boxShadow: 'inset 0 2px 2px 0 rgba(132, 130, 156, 0.2)',
    border: 'solid 1px #b0aeca',
    fontWeight: 'normal',
    marginTop: '10px',
    marginLeft: '0',
  };

  const handleSelectEndorsementType = event => {
    setEndorsementType(event.target.value);
  };

  const setError = error => {
    setEffDateError(error);
  };

  const showEndorsmentForm = () => {
    switch (endorsementType) {
      case 'NameChange':
        return (
          <NameChange
            clientId={clientId}
            effDate={new Date(effDate)}
            policyIds={selectedPolicesState.ids}
            setEffDateError={setError}
          />
        );
      case 'ChangeDesignatedOfficerContactPerson':
        return (
          <ChangeDesignatedOfficerContactPerson
            clientId={clientId}
            effDate={new Date(effDate)}
            policyIds={selectedPolicesState.ids}
            setEffDateError={setError}
          />
        );
      case 'MailingAddressChange':
        return (
          <MailingAddressChange
            clientId={clientId}
            effDate={new Date(effDate)}
            policyIds={selectedPolicesState.ids}
            setEffDateError={setError}
          />
        );
      case 'PolicyLimitChange':
      case 'CoverageRetentionChange':
      case 'DirectorsOfficersCoverageChange':
      case 'EmploymentPracticesCoverageChange':
      case 'FiduciaryCoverageChange':
      case 'CrimeCoverageChange':
        return (
          <General
            clientId={clientId}
            effDate={new Date(effDate)}
            policyIds={selectedPolicesState.ids}
            setEffDateError={setError}
            endorsementType={endorsementType}
          />
        );
      default:
        return (
          <Other
            clientId={clientId}
            effDate={new Date(effDate)}
            policyIds={selectedPolicesState.ids}
            setEffDateError={setError}
          />
        );
    }
  };

  const handleEffectiveDateChange = date => {
    setEffDate(date);
  };

  const showPolicies = () => (
    <SelectedPoliciesDispatch.Provider value={selectedPolicesDispatch}>
      <div className={style.main}>
        <h1 className={style.title}>Request New Endorsements</h1>
        <span className={style.hint}>
          Select the policy or policies to include in the endorsement request:
        </span>
        <Policies
          submitBtnText="Continue"
          clientId={clientId}
          requestType="RequestPolicyDocument"
        />
      </div>
    </SelectedPoliciesDispatch.Provider>
  );

  const showForm = () => (
    <div className={style.main}>
      <h1 className={style.title}>Request New Endorsement</h1>
      <div className={style.submitForm}>
        <div className={`form-group ${style.info}`}>
          <div className={style.label}>Type of Change: </div>
          <Select
            styles={endorsementTypeStyle}
            options={endorsementTypes}
            value={endorsementType}
            onChange={handleSelectEndorsementType}
          />
        </div>
        <div className={`form-group ${style.info}`}>
          <div className={style.label}>Effective Date for this Request: </div>
          <DatePicker
            minDate={new Date()}
            selectedDate={effDate}
            onChange={handleEffectiveDateChange}
          />
          <Error error={effDateError} />
        </div>
        {showEndorsmentForm()}
      </div>
    </div>
  );

  return (
    <>
      {!stepTwo && showPolicies()}
      {stepTwo && showForm()}
    </>
  );
});

EndorsementsRequestPage.propTypes = {
  clientId: PropTypes.string.isRequired,
};

export default EndorsementsRequestPage;
